import { GlobalService } from 'src/app/_services/global.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AppMainComponent } from './app.main.component';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { AppBaseDataService } from './_services/app-base-data.service';
import { BusinessSetupProgressService } from './_services/business-setup-progress.service';
import { UserService } from './_services/user.service';
import { ConnMessageService } from './_services/conn-message.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { PlanDataService } from './_services/plan-data.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./app.topbar.component.scss']
})
export class AppTopBarComponent implements OnInit {
    _globals = GlobalService
    breadcrumbs: MenuItem[];
    menuActiveMobile: boolean = false;
    setupCompletedCount: number | null = null;
    setupTotalCount = 6;
    isSetupProgressRefreshing = false;
    // Same allow-list as theme-overview.component.ts's isYouksStoreUser() — these accounts'
    // stores are already live in production, so the setup-progress pill never applies to them.
    private readonly youksStoreEmailAllowList = new Set([
        'zilonwebmaster@gmail.com',
        'zilonwebsmaster@gmail.com',
        'younksnutritioncentral@yahoo.com'
    ]);
    @ViewChild('op') profilePanel: OverlayPanel;

    constructor(
        public appMain: AppMainComponent,
        private readonly _router: Router,
        public _abd: AppBaseDataService,
        public _userServices: UserService,
        private readonly _connMessageService: ConnMessageService,
        public readonly _businessSetupProgress: BusinessSetupProgressService,
        private readonly _planData: PlanDataService,
    ) { }

    get isYouksStoreUser(): boolean {
        const email = String(this._globals.userInfo?.email ?? this._globals.userInfo?.username ?? '').trim().toLowerCase();
        return this.youksStoreEmailAllowList.has(email);
    }

    get currentPlanName(): string {
        const setup = this._globals.userInfo?.businessSetup?.[0];
        const planCosmosId = setup?.subscription?.planId ?? setup?.subscription?.PlanId;
        if (!planCosmosId) return 'Free';
        const matchedPlan = this._planData.list.find((p: any) => String(p.cosmosId) === String(planCosmosId));
        return matchedPlan?.planName || 'Free';
    }

    ngOnInit() {
        this.breadcrumbs = [
            { label: 'Categories' },
            { label: 'Sports' },
            { label: 'Football' },
            { label: 'Countries' },
            { label: 'Spain' },
            { label: 'F.C. Barcelona' },
            { label: 'Squad' },
            { label: 'Lionel Messi', url: 'https://en.wikipedia.org/wiki/Lionel_Messi' }
        ];

        if (!this._abd.isAdmin) {
            this._businessSetupProgress.progress$.subscribe((progress) => {
                this.setupCompletedCount = progress.completedCount;
                this.setupTotalCount = progress.totalCount;
            });
            this._businessSetupProgress.refreshing$.subscribe((refreshing) => {
                this.isSetupProgressRefreshing = refreshing;
            });
            this._businessSetupProgress.getProgress().subscribe();
        }
    }

    goToBusinessSetup(): void {
        this._router.navigate(['/app/business-setup']);
    }

    get isFreeTrial(): boolean {
        return !!this._globals.userInfo?.businessSetup?.[0]?.isFreeTrial;
    }

    /** Same cosmosId-matching fix as billing-and-plans.component.ts's isFreePlan:
     *  businessSetup[0].subscription.planId is a cosmosId string, not a small numeric id, so it
     *  must be matched against the catalog rather than compared directly. Used to also show the
     *  topbar "Upgrade" pill for a Free-plan (non-trial) account, which previously saw nothing
     *  since the pill was gated on isFreeTrial alone. */
    get isFreePlan(): boolean {
        const setup = this._globals.userInfo?.businessSetup?.[0];
        const cosmosId = setup?.subscription?.planId ?? setup?.subscription?.PlanId;
        if (!cosmosId) return false;
        const matched = this._planData.list.find((p: any) => String(p.cosmosId) === String(cosmosId));
        return !!matched && (Number(matched.id) === 1 || String(matched.planName || '').trim().toLowerCase() === 'free');
    }

    get freeTrialEndDate(): string | Date | null {
        return this._globals.userInfo?.businessSetup?.[0]?.freeTrialEndDate ?? null;
    }

    // Only affects very small screens, where the plan pill collapses to a dot (see scss).
    planPillExpanded = false;

    togglePlanPill(): void {
        this.planPillExpanded = !this.planPillExpanded;
    }

    goToSubscription(): void {
        // The topbar "Upgrade" pill jumps straight to the plan-comparison page (matches the
        // LincSell Signup.dc.html prototype, where the top-level upgrade CTA skips the billing
        // summary screen entirely) rather than /app/billing-and-plans.
        // Clear the one-time checkout lock (see PaymentPageComponent.CHECKOUT_LOCK_KEY) — this is
        // a deliberate re-entry into plan picking, not a browser Back landing on a stale checkout.
        try { sessionStorage.removeItem('checkout-just-completed'); } catch { /* ignore */ }
        this._router.navigate(['/change-plan']);
    }

    settingsClicked() {
        this._router.navigate(['app/settings-main'])
    }
    // isCheckIn(){
    //     if(this._abd?.locations.length > 0){
    //         this._userServices.isCheckIn = true
    //     }else{
    //         this._connMessageService.showToastMessage(
    //             `Location required for check-in. Please add a location to proceed.`,
    //             'error'
    //         );    
    //     }
    // }
    logoutButtonClicked() {
        this._abd.showSpinner()
        localStorage.removeItem('user')
        // Checkout cart/plan pick must not survive to whatever account logs in next on this same
        // browser — this button bypasses UserService.logout()/softLogout() (which already clear
        // these via clearSignupStateStorage()), so it was left stale here after sign-out.
        localStorage.removeItem('checkout-cart-state')
        localStorage.removeItem('selectedPlanDetails')
        sessionStorage.clear();

        if (window.location.href.includes('/handheld')) {
            try {

                eval('invokeCSharpAction("logout")')
                window.location.reload()
            }
            catch {

            }
            this._router.navigate(['handheld/signin'])
            window.location.reload()

        }
        else
            window.location.reload()
    }
    // checkOutOnLogOut(): Promise<any> {
    //      return new Promise<any>((resolve, reject) => {

    //         this._abd.showSpinner()
    //         try {
    //                     this._abd.getTimeTrackingConfiguration().subscribe(res=>{
    //                 if(res.data.autoCheckoutOnLogout === true){
    //            this._userServices.getTimeAttendance(this._globals.userInfo.userID).subscribe((res)=>{

    //           let obj ={
    //             UserId:        res.data?.userId,
    //             EmployeeID:    res.data?.userId,
    //             EmployeeRole:  res.data?.employeeRole,
    //             EmployeeEmail: res.data?.employeeEmail, 
    //             EmployeeName:  res.data?.employeeName,
    //             LocationName:  res.data?.locationName,
    //             RegisterName:  res.data?.registerName,
    //             locationid:    res.data?.locationId,
    //             Type:          1,
    //             Method:        res.data?.method,
    //             reason:        1,
    //            }
    //         this._userServices.checkOutUser(obj).subscribe((res)=>{
    //          resolve ('OK');
    //         })
    //         })
    //                 }else{
    //                     resolve ('OK'); 
    //                 }
    //             })
    //         } catch (error) {
    //             resolve ('OK'); 
    //         } 
    //      });
    //    }

    changePasswordClicked() {
        this._router.navigate(['pages/change-password'])
    }

    toggleProfilePanel(event: Event, target?: HTMLElement) {
        // Ensure the mobile topbar menu closes so only the profile panel remains visible
        this.appMain.hideTopMenu();
        this.appMain.topMenuActive = false;
        this.appMain.menuClick = true;
        this.appMain.topMenuButtonClick = true;
        this.profilePanel?.toggle(event, target);
        event.preventDefault();
        event.stopPropagation();
    }
}
